import type { Components } from '@mui/material/styles';

export default function MUIListItemButton(): Components['MuiListItemButton'] {
  return {};
}
